module.exports = {
	"name": "youboralib",
	"type": "lib",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.0-rc.infinity",
	"built": "2017-05-19",
	"repo": "https://bitbucket.org/npaw/lib-plugin-js.git"
};


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0